import { useMePartner } from "../../../swr";

/**
 * The parts of the buyer's company address (the legal entity on the invoice)
 * that are still empty. The BE refuses to take payment until street, city
 * and country are filled in, so checkout checks it up-front and points the
 * buyer at the company profile instead of failing on the payment step.
 */
export function useCompanyAddressGaps(): { missing: string[]; isLoading: boolean } {
  const { partner, isLoading } = useMePartner();
  if (!partner) return { missing: [], isLoading };

  const missing = [
    !partner.street && "street",
    !partner.city && "city",
    !partner.country?.id && "country",
  ].filter((field): field is string => Boolean(field));
  return { missing, isLoading };
}
